import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { setBreadCrumbs } from '../../actions/breadcrumbs.js';
import SaxsExperimentListContainer from './helpers/SaxsExperimentListContainer.js';
import SaxsSideBar from '../../components/saxs/SaxsSideBar';
import ExperimentListPanel from '../../components/saxs/ExperimentListPanel';
import DataCollectionListPanel from '../../components/saxs/DataCollection/DataCollectionListPanel.js';
import SaxsDataCollectionListMenuContainer from './helpers/SaxsDataCollectionListMenuContainer.js';
import SaxsDataCollectionsContainer from './helpers/SaxsDataCollectionsContainer.js';
import { Grid, Row, Col } from 'react-bootstrap';
import UserMessage from '../../components/saxs/UserMessage.js';
import { INFO_MESSAGE_TYPE } from '../../constants/UserMessages.js';
import SaxsHPLCSummaryDataContainer from './helpers/SaxsHPLCSummaryDataContainer.js';
import _ from 'lodash';
import SaxsHPLCSummaryPlot from '../../components/saxs/SaxsHPLCSummaryPlot.js';
import SaxsHPLCFrameContainer from './helpers/SaxsHPLCFrameContainer.js';
import FramePlotter from '../../components/saxs/FramePlotter.js';
import SaxsSimplePlotter from '../../components/saxs/SaxsSimplePlotter.js';
import { VIEW_DATASET_SUMMARY, VIEW_DATASET_PLATESETUP } from '../../constants/saxs.js';
import SaxsHPLCSummaryTable from '../../components/saxs/SaxsHPLCSummaryTable.js';
import SaxsPlateTable from '../../components/saxs/PlateSetup/SaxsPlatesTable.js';
import SaxsPlatesPanel from '../../components/saxs/PlateSetup/SaxsPlatesPanel.js';
import SaxsExperimentContainer from './helpers/SaxsExperimentContainer.js';
import Loading from '../../components/Loading.js';

/**
 * React container used to handle SAXS data
 */
class SaxsDataCollectionSummaryContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        if ((!this.props.user) || (!this.props.user.token)) {
            return null;
        }

        return (<SaxsExperimentListContainer token={this.props.user.token} proposal={this.props.proposal} sessionId={this.props.sessionId}>
            {(experiments, selectedExperimentId, onExperimentClicked) => {

                return < SaxsSideBar
                    sideBarComponent={<ExperimentListPanel
                        experiments={experiments}
                        selectedExperimentId={selectedExperimentId}
                        onExperimentClicked={onExperimentClicked} />}
                >

                    {selectedExperimentId ?
                        <SaxsDataCollectionsContainer
                            experimentId={selectedExperimentId}
                            proposal={this.props.proposal}
                            token={this.props.user.token}
                        >
                            {dataCollections => {

                                let selectedExperiment = _.find(experiments, experiment => experiment.id === selectedExperimentId);
                                if (selectedExperiment) {
                                    if (selectedExperiment.type === 'HPLC') {
                                        return <SaxsHPLCSummaryDataContainer
                                            experimentId={selectedExperimentId}
                                            proposal={this.props.proposal}
                                            token={this.props.user.token}>
                                            {(HPLCDataSeries, selectedFrames, selectFrame) => {

                                                if (HPLCDataSeries) {
                                                    return <SaxsHPLCFrameContainer
                                                        experimentId={selectedExperiment.id}
                                                        frameId={_.find(selectedFrames, selectedFrame => selectedFrame.isVisible === true) ? _.find(selectedFrames, selectedFrame => selectedFrame.isVisible === true).frameId : null}
                                                        proposal={this.props.proposal}
                                                        token={this.props.user.token} >
                                                        {frameDataSeries => {
                                                            return <Grid fluid={true}>
                                                                <Row>
                                                                    <Col xs={12} >
                                                                        <DataCollectionListPanel
                                                                            dataCollections={dataCollections}
                                                                            experimentId={selectedExperimentId}
                                                                            proposal={this.props.proposal}
                                                                            sessionId={this.props.sessionId}
                                                                            token={this.props.user.token}
                                                                            view={VIEW_DATASET_SUMMARY} />
                                                                    </Col>
                                                                </Row>
                                                                <Row>
                                                                    <Col xs={12} sm={6}>
                                                                        <SaxsHPLCSummaryPlot
                                                                            dataSeries={HPLCDataSeries}
                                                                            divId='SaxsHplcSECFrameDiv'
                                                                            experimentId={selectedExperimentId}
                                                                            onPlotPointClicked={selectFrame}
                                                                            proposal={this.props.proposal}
                                                                            token={this.props.user.token} />
                                                                    </Col>
                                                                    <Col xs={12} sm={6}>
                                                                        <SaxsSimplePlotter dataSeries={frameDataSeries} divId='SaxsHplcFrameDiv' />
                                                                        <SaxsHPLCSummaryTable frames={selectedFrames} />
                                                                    </Col>
                                                                </Row>
                                                            </Grid>
                                                        }}
                                                    </SaxsHPLCFrameContainer>
                                                } else { return 'HPLC data not received yet' }
                                            }
                                            }
                                        </SaxsHPLCSummaryDataContainer>
                                    } else {
                                        return <SaxsDataCollectionListMenuContainer >
                                            {view => {
                                                if (view !== VIEW_DATASET_PLATESETUP) {
                                                    return (<Col xs={12}>
                                                        <DataCollectionListPanel
                                                            dataCollections={dataCollections}
                                                            experimentId={selectedExperimentId}
                                                            proposal={this.props.proposal}
                                                            sessionId={this.props.sessionId}
                                                            token={this.props.user.token}
                                                            view={view} />


                                                    </Col>);
                                                } else {
                                                    return <SaxsExperimentContainer token={this.props.user.token} proposal={this.props.proposal} experimentId={selectedExperimentId} >
                                                        {(experiment, fetching, fetched) => {
                                                            return (<Grid fluid>
                                                                <Row>
                                                                    <Col xs={12} md={4}>
                                                                    {fetching == false && fetched === true ? <SaxsPlatesPanel experiment={experiment} /> : null}
                                                                    {fetching == true && fetched === false ? <Loading/>  : null}
                                                                        
                                                                    </Col>
                                                                    <Col xs={12} md={8}>
                                                                        <SaxsPlateTable dataCollections={dataCollections} />
                                                                    </Col>
                                                                </Row>
                                                            </Grid>);
                                                        }}
                                                    </SaxsExperimentContainer>
                                                }
                                            }}
                                        </SaxsDataCollectionListMenuContainer>
                                    }
                                }
                            }}
                        </SaxsDataCollectionsContainer >
                        :
                        <Grid>
                            <Row>
                                <Col> <UserMessage type={INFO_MESSAGE_TYPE} message={'Please select an experiment from the list'} /> </Col>
                            </Row>
                        </Grid>
                    }
                </SaxsSideBar>

            }
            }
        </SaxsExperimentListContainer>);
    }
}

function mapStateToProps(state) {
    return {
        user: state.user
    };
}

function mapDispatchToProps(dispatch) {
    return {
        setBreadCrumbs: (breadCrumbs) => dispatch(setBreadCrumbs(breadCrumbs))
    };
}

SaxsDataCollectionSummaryContainer.propTypes = {
    /** proposal number */
    proposal: PropTypes.string,
    /** session identifier */
    sessionId: PropTypes.string
};

export default connect(mapStateToProps, mapDispatchToProps)(SaxsDataCollectionSummaryContainer);


// WEBPACK FOOTER //
// ./src/containers/saxs/SaxsDataCollectionSummaryContainer.js